<template>
  <ul class="contacts-other">
    <li
      v-for="contact in otherContacts"
      v-bind:key="contact.address"
    >
      <font-awesome-icon
        class="icon"
        v-bind:icon="contact.icon"
      ></font-awesome-icon><!--
   --><a v-bind:href="contact.reference"><!--
     --><span v-bind:itemprop="contact.itemProp"
        >{{ contact.address }}</span><!--
   --></a><!--
   --><span v-if="contact.name">{{ contact.name }}</span>
    </li>
  </ul>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faViber } from '@fortawesome/free-brands-svg-icons'

export default {
  name: 'ContactsOther',
  components: { FontAwesomeIcon },
  data: function () {
    return {
      otherContacts: [
        {
          address: '+375 29 8888-099',
          reference: 'viber://chat?number=375298888099',
          name: '(viber)',
          itemProp: null,
          icon: faViber
        },
        {
          address: 'contact@stylegold.by',
          reference: 'mailto:contact@stylegold.by',
          name: '',
          itemProp: 'email',
          icon: faEnvelope
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
  .contacts-other {
    margin-top: 0;
    .icon {
      color: $default-link-color;
      padding-right: 0.5em;
    }
    a {
      text-decoration: none;
      font-family: "Gotham Pro Regular", $font-stack;
    }
    & > li {
      display: block;
      margin: 0 0 0.75em 0;
      &:last-child { margin: 0; }
      & > span {
        padding-left: 0.5em;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/ContactsOther.vue